import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'HEGXIB Nigeria - Digital Solutions & Technology Services',
  description = 'Leading provider of digital solutions, technology services, web development, mobile apps, and IT consulting in Nigeria.',
  keywords = 'HEGXIB, Nigeria, digital solutions, technology services, web development, mobile apps, IT consulting, software development',
  image = 'https://ng.hegxib.me/assets/HXB-NG-NO-BACKGROUND.png',
  url = 'https://ng.hegxib.me',
  type = 'website',
  structuredData = null
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
